import { ref, computed } from 'vue';
import { acceptHMRUpdate, defineStore } from 'pinia';
import { getPrintList, getPrintTemplateList, getShopConfigApi, getmemberEnum, handoverCashInfo, getShiftConfig } from '../requestPub/interface';
import { getPermissions } from '../requestPub/permissions';
import nativePlugin from '../utils/nativePlugin.js';

export const usePublicStore = defineStore('public', () => {
    const uuid = ref(uni.getStorageSync('uuid') || '');
    const lastTime = ref(new Date().getTime());
    const downloadTip = ref(false);
    const printList = ref([]);
    const defaultPrinter = ref(null);
    const printTemplateList = ref([]);
    const authCode = ref([]);
    const memerEnum = ref();
    const appHide = ref(1);
    //  无网络弹窗
    const isOffline = ref(false);
    // H5端网络
    const isOfflineH5 = ref(false);
    // 当前页面导航
    const tabsNav = ref('table');
    const setDownloadTip = (status) => {
        downloadTip.value = status;
    };
    // 配置信息
    const config = ref(uni.getStorageSync('shop_config') || {});
    // 交接班配置
    const shiftConfig = ref({});
    //主题
    const theme = ref('Light');

    // 获取系统基本信息，用于初始兜底和环境判断
    const sysInfo = uni.getSystemInfoSync();

    //系统信息
    const systemInfo = ref({
        appName: '米呱呱智慧收银系统', // 应用名称
        appVersion: '1.0.0', // 应用版本
        deviceCode: sysInfo.deviceId || '', // 初始化同步给兜底的 deviceId，兼容旧逻辑
        wifiName: '', // wifi 名称
        wifiSignal: '' // wifi 信号
    });

    /**
     * 核心需求：获取设备码 (商米设备获取序列号，其他获取 deviceId)
     * 调用该方法会异步更新 systemInfo.deviceCode，并返回最新的 deviceCode
     */
    const getDeviceCode = async () => {
        try {
            // 获取最新系统信息以防有变
            const currentSysInfo = uni.getSystemInfoSync();
            const platform = currentSysInfo.uniPlatform || currentSysInfo.platform;
            const brand = currentSysInfo.deviceBrand || currentSysInfo.brand;
            let finalDeviceCode = currentSysInfo.deviceId || '';

            // 判断：当前环境必须是 App，并且品牌为商米 (Sunmi)
            if (platform === 'app' && brand?.toLowerCase() === 'sunmi') {
                try {
                    // 调用 nativePlugin 获取序列号 (Promise形式)
                    const res = await nativePlugin.getSerialNo({});
                    if (res && res.code === 0 && res.msg) {
                        finalDeviceCode = res.msg; // 成功获取商米序列号
                    } else {
                        console.warn('获取商米序列号失败，降级使用 deviceId，响应:', res);
                    }
                } catch (err) {
                    console.error('调用商米 getSerialNo 异常，降级使用 deviceId:', err);
                    finalDeviceCode = currentSysInfo.deviceId; // 发生异常时兜底
                }
            }

            // 更新 store 里的数据
            systemInfo.value = {
                ...systemInfo.value,
                deviceCode: finalDeviceCode,
                isSunmi: brand?.toLowerCase() === 'sunmi'
            };

            return finalDeviceCode;
        } catch (error) {
            console.error('获取设备信息整体异常:', error);
            return systemInfo.value.deviceCode; // 极度异常情况返回现有状态
        }
    };
    // 交接班配置
    const getShiftData = async () => {
        const res = await getShiftConfig();
        shiftConfig.value = res.data;
    };
    //设置系统信息
    const setSystemInfo = (value) => {
        systemInfo.value = { ...systemInfo.value, ...value };
    };
    const getAuth = () => {
        // 获取权限
        getPermissions().then((res) => {
            if (res.data.length) {
                authCode.value = res.data[0]?.label.find((e) => e.scene_type == 2)?.label || [];
            }
        });
    };
    // 网络
    const setOffline = (status) => {
        if (isOffline.value === status) return;
        isOffline.value = status;
    };
    const initNetworkListener = () => {
        console.log('初始化');
        // 先获取一次当前网络状态
        uni.getNetworkType({
            success: (res) => {
                setOffline(res.networkType === 'none');
            }
        });

        // 监听网络变化
        let timer = null;
        uni.onNetworkStatusChange((res) => {
            clearTimeout(timer);
            timer = setTimeout(() => {
                setOffline(res.networkType === 'none');
            }, 300);
        });
    };
    // 使用 async/await
    const getShopConfig = async () => {
        try {
            // 等待配置加载
            const res = await getShopConfigApi();
            if (res.code == 200) {
                config.value = res.data;
                uni.setStorageSync('shop_config', res.data);
            } else {
                throw new Error(res.msg || '配置加载失败');
            }
        } catch (error) {
            console.error('获取店铺配置异常:', error);
            // throw error;
        } finally {
            // getAuth();
            getPrinterList();
            getPrinterTemplateList();
            getMemberEnum();
        }
    };
    // 交接班弹窗
    const shiftModel = () => {
        return handoverCashInfo().then((res) => {
            if (res?.code == 200) {
                return res.data;
            }
            return null;
        });
    };
    const updateConfig = async (data) => {
        config.value = data;
        uni.setStorageSync('shop_config', data);
    };
    // 设置主题
    const setTheme = (value) => {
        theme.value = value;
    };
    const lastTimeUpdata = (time) => {
        lastTime.value = time;
    };
    const deviceInfo = uni.getWindowInfo();
    const screen_orientation = ref(deviceInfo.screenWidth > deviceInfo.screenHeight ? 'landscape' : 'portrait');
    //页面禁止滚动
    const hiddenPageScorll = ref(false);
    const setPageScorll = (status) => {
        hiddenPageScorll.value = status;
    };
    //  是否显示桌号（TabNum 用）
    const tabNumVisible = ref(false);
    const setTabNumVisible = (status) => {
        tabNumVisible.value = !!status;
    };
    //  新增：当前首页 tabbar 的 key（用 key 判断是不是计分页）
    // 默认是点单页：home-order（跟你 TarBar 里保持一致）
    const currentHomeTabKey = ref('home-order');
    const setCurrentHomeTabKey = (key) => {
        currentHomeTabKey.value = key;
    };
    // 小程序获取胶囊的位置信息
    const RectStyle = computed(() => {
        return {
            cusHeight: uni.upx2px(80) + deviceInfo.statusBarHeight,
            height: 0,
            top: 0,
            width: 0
        };
    });
    const watchScreen = () => {
        uni.onWindowResize((res) => {
            screen_orientation.value = res.deviceOrientation;
            console.log('当前屏幕方向', screen_orientation.value);
        });
    };
    //  获取系统信息大小
    const getSystemInfoSize = () => {
        if (deviceInfo.screenWidth < 1500 && deviceInfo.screenWidth >= 1100) {
            return 'system-middle';
        } else if (deviceInfo.screenWidth < 1100) {
            return 'system-small';
        } else {
            return '';
        }
    };
    //获取打印机列表
    const getPrinterList = () => {
        getPrintList().then((res) => {
            if (res.code == 200) {
                printList.value = res.data.list;
                defaultPrinter.value = res.data.list.find((item) => item.is_default);
            }
        });
    };
    const getPrinterTemplateList = () => {
        getPrintTemplateList().then((res) => {
            if (res.code == 200) {
                printTemplateList.value = res.data.list;
            }
        });
    };
    const getMemberEnum = () => {
        getmemberEnum().then((res) => {
            if (res.code == 200) {
                memerEnum.value = res.data;
            }
        });
    };
    return {
        getSystemInfoSize,
        uuid,
        hiddenPageScorll,
        setPageScorll,
        RectStyle,
        watchScreen,
        screen_orientation,
        theme,
        setTheme,
        lastTime,
        lastTimeUpdata,
        tabNumVisible,
        setTabNumVisible,
        shiftModel,
        getAuth,
        // 配置信息
        config,
        getShiftData,
        shiftConfig,
        //  新增返回
        currentHomeTabKey,
        setCurrentHomeTabKey,
        downloadTip,
        setDownloadTip,
        //系统信息
        systemInfo,
        setSystemInfo,
        getDeviceCode, // 暴露出去，供组件挂载或 App 启动时调用
        getShopConfig,
        getPrinterList,
        printList,
        defaultPrinter,
        getPrinterTemplateList,
        printTemplateList,
        memerEnum,
        tabsNav,
        authCode,
        isOffline,
        setOffline,
        isOfflineH5,
        initNetworkListener,
        appHide,
        updateConfig
    };
});

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(usePublicStore, import.meta.hot));
}
